import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/query/cert',
    name: 'query_cert',
    component: () => import('../views/query/CertView.vue')
  },
  {
    path: '/mock',
    name: 'mock',
    component: () => import('../views/MockView.vue')
  },
  {
    path: '/facebody',
    name: 'facebody',
    component: () => import('../views/AacebodyView.vue')
  },
  {
    path: '/course/index',
    name: 'course',
    component: () => import('../views/course/IndexView.vue')
  },
  {
    path: '/course/detail',
    component: () => import('../views/course/DetailView.vue')
  },
  {
    path: '/course/prove',
    component: () => import('../views/course/ProveView.vue')
  },
  {
    path: '/course/print',
    component: () => import('../views/course/PrintView.vue')
  },
  {
    path: '/course/print1',
    component: () => import('../views/course/Print1View.vue')
  },
  {
    path: '/message',
    name: 'message',
    component: () => import('../views/message/IndexView.vue')
  },
  {
    path: '/practice/sequence',
    name: 'practice_sequence',
    component: () => import('../views/practice/SequenceView.vue')
  },
  {
    path: '/practice/exam',
    name: 'practice_exam',
    component: () => import('../views/practice/ExamView.vue')
  },
  {
    path: '/practice/records',
    name: 'practice_records',
    component: () => import('../views/practice/RecordView.vue')
  },
]

const publicPath = process.env.BASE_URL;

const router = new VueRouter({
  mode: 'history',
  base: publicPath,
  routes
})

export { publicPath }

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
